export const agentEndpoints = {
  postAIVehicleImage: "/api/vehicle-images/label",
};
